import { useState } from "react";
import { Form } from "antd";

import { type ScheduledAiReportAutomation } from "@fitness-app/data-models/entities/AutomationTemplate";
import { type ProgramAutomationScheduledTask } from "@fitness-app/data-models/entities/ProgramAutomation";

import { type AiReportTaskFormModel } from "./types";

// scheduleTiming lives on the ProgramAutomationScheduledTask wrapper, so keep it
// on the edited task to preload the package-anchor fields (TRE-1612).
type EditedAiReportTask = ScheduledAiReportAutomation & Pick<ProgramAutomationScheduledTask, "scheduleTiming">;

export const useAiReportTaskForm = () => {
  const [visible, toggleVisibility] = useState(false);
  const [formController] = Form.useForm<AiReportTaskFormModel>();
  const [editedTask, setTask] = useState<null | EditedAiReportTask>(null);

  const closeModal = () => {
    toggleVisibility(false);
    setTask(null);
  };

  const openModal = (task?: EditedAiReportTask) => {
    if (task) {
      setTask(task);
    }
    toggleVisibility(true);
  };

  return {
    visible,
    closeModal,
    openModal,
    editedTask,
    formController,
  };
};
